import GALLERY_CONSTS from '../../common/constants';
import { isInPreset } from '../../components/helpers/layoutHelper';
export var formatTitle = function formatTitle(title) {
  return title.replace(/_/g, ' ').split(' ').map(function (word) {
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }).join(' ');
};
export var createOptions = function createOptions(constName) {
  return Object.entries(GALLERY_CONSTS[constName]).map(function (_ref) {
    var title = _ref[0],
        value = _ref[1];
    return {
      value: value,
      title: formatTitle(title)
    };
  });
};
export var always = function always() {
  return true;
}; //export const imageMargin = (styleParams) => styleParams.galleryLayout !== 3 && styleParams.galleryLayout !== 5;

export var imageMargin = function imageMargin(styleParams) {
  return !isInPreset(styleParams, 'imageMargin');
};